// extracted by mini-css-extract-plugin
export default {"top_100_card":"Top100Coins_top_100_card__ufziI","no_coins":"Top100Coins_no_coins__Oxti2"};